var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMacosLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9236 1.3457C28.6837 6.72368 24.2011 20.7064 24.2011 33.6136H32.2681C32.2681 40.4355 32.8059 51.3609 34.9571 57.8145M14.7897 17.4796V22.8576M41.6795 17.4796V22.8576M12.1007 38.9915C13.8942 41.6805 19.8987 47.0585 29.5791 47.0585C39.2595 47.0585 44.8176 41.6805 47.0575 38.9915M1.34473 47.0585V12.1017C1.34473 9.249 2.47794 6.51318 4.49507 4.49605C6.5122 2.47892 9.24802 1.3457 12.1007 1.3457H47.0575C49.9102 1.3457 52.646 2.47892 54.6631 4.49605C56.6803 6.51318 57.8135 9.249 57.8135 12.1017V47.0585C57.8135 49.9112 56.6803 52.647 54.6631 54.6641C52.646 56.6812 49.9102 57.8145 47.0575 57.8145H12.1007C9.24802 57.8145 6.5122 56.6812 4.49507 54.6641C2.47794 52.647 1.34473 49.9112 1.34473 47.0585Z",
    stroke: "black",
    strokeWidth: 2.68899,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacosLogo);
export default __webpack_public_path__ + "static/media/macos_logo.8c1b668ebaf0f58f21ecb04a048b9084.svg";
export { ForwardRef as ReactComponent };